import { authFetch } from '../../utils/authFetch';

import {
  RESET_SECURITY_STATE,
  UPDATE_SECURITY_ASSESSMENT,
  UPDATE_SCENARIO_ASSESSMENT,
  //SAVE_SECURITY_ASSESSMENT_SUCCESS,
  //SAVE_SECURITY_ASSESSMENT_FAILURE,
  LOAD_SECURITY_ASSESSMENT,
  SET_ACTIVE_IDS,
  GENERATE_SECURITY_RISKS_START,
  GENERATE_SECURITY_RISKS_SUCCESS,
  GENERATE_SECURITY_RISKS_FAILURE,
  FETCH_SECURITY_ASSESSMENT_START,
  FETCH_SECURITY_ASSESSMENT_SUCCESS,
  FETCH_SECURITY_ASSESSMENT_FAILURE,
  SAVE_SECURITY_RISK_START, 
  SAVE_SECURITY_RISK_SUCCESS, 
  SAVE_SECURITY_RISK_FAILURE,
  FETCH_SECURITY_RISKS_START,
  FETCH_SECURITY_RISKS_SUCCESS,
  FETCH_SECURITY_RISKS_FAILURE,
  DISCARD_SECURITY_RISK_START,
  DISCARD_SECURITY_RISK_SUCCESS,
  DISCARD_SECURITY_RISK_FAILURE,
  GENERATE_SECURITY_CONTROLS_START,
  GENERATE_SECURITY_CONTROLS_SUCCESS,
  GENERATE_SECURITY_CONTROLS_FAILURE,
  FETCH_SECURITY_CONTROLS_START, 
  FETCH_SECURITY_CONTROLS_SUCCESS, 
  FETCH_SECURITY_CONTROLS_FAILURE, 
  SAVE_SECURITY_CONTROL_START, 
  SAVE_SECURITY_CONTROL_SUCCESS,
  SAVE_SECURITY_CONTROL_FAILURE,
  LOAD_SCENARIOS_SUCCESS,
  SAVE_SCENARIO_SUCCESS,
  SAVE_SCENARIO_FAILURE,
  DELETE_SCENARIO_SUCCESS,
  DELETE_SCENARIO_FAILURE,
} from './actionTypes';

//import loadSecurityRisks from '../../loadSecurityRisks'

export const resetSecurityState = () => ({
  type: RESET_SECURITY_STATE
});

export const updateSecurityAssessment = (modelId, assessmentData) => ({
  type: UPDATE_SECURITY_ASSESSMENT,
  payload: { modelId, assessmentData }
});

export const updateScenarioAssessment = (modelId, scenarioId, assessmentData) => ({
  type: UPDATE_SCENARIO_ASSESSMENT,
  payload: { modelId, scenarioId, assessmentData }
});



export const loadSecurityAssessment = (modelId, assessmentData) => ({
  type: LOAD_SECURITY_ASSESSMENT,
  payload: { modelId, assessmentData }
});

export const setActiveIds = (modelId, assessmentUuid) => ({
  type: SET_ACTIVE_IDS,
  payload: { modelId, assessmentUuid }
});

export const generateSecurityRisks = (modelId, assessmentUuid, assessmentData, securityRiskCatalogue, riskArea) => async (dispatch) => {
  dispatch({ type: GENERATE_SECURITY_RISKS_START });
  try {
      const response = await authFetch('/.netlify/functions/generateSecurityRisks', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({ modelId, assessmentUuid, assessmentData, securityRiskCatalogue, riskArea }),
      });

      if (!response.ok) {
          throw new Error(`Error generating security risks: ${response.status} ${response.statusText}`);
      }

      const securityRisksResponse = await response.json();

      dispatch({
          type: GENERATE_SECURITY_RISKS_SUCCESS,
          payload: {
              modelId,
              securityRisks: securityRisksResponse
          }
      });
      return;
  } 
  catch (error) {
      console.error('Error generating security risks:', error.message);
      dispatch({
          type: GENERATE_SECURITY_RISKS_FAILURE,
          payload: error.message
      });
  }
};

export const fetchSecurityAssessment = (modelId, assessmentUuid) => async (dispatch) => {
  dispatch({ type: FETCH_SECURITY_ASSESSMENT_START });
  try {
    const response = await authFetch(`/.netlify/functions/fetchSecurityAssessment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ modelId, assessmentUuid })
    });

    if (!response.ok) {
      throw new Error('Failed to fetch assessment data');
    }
    const { assessmentData } = await response.json();
    console.log ('sec asmt data received from DB to dispatch to reducer', assessmentData)
    dispatch({ type: FETCH_SECURITY_ASSESSMENT_SUCCESS, payload: { modelId, assessmentData } });
  } catch (error) {
    dispatch({ type: FETCH_SECURITY_ASSESSMENT_FAILURE, payload: error.message });
  }
};

// ─────────── Scenarios: fetch/save/delete ───────────
export const fetchScenarios = (modelId, assessmentUuid) => async (dispatch) => {
  try {
    console.log('[AC] fetchScenarios', { modelId, assessmentUuid });
    const res = await authFetch('/.netlify/functions/fetchScenarios', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, assessmentUuid }),
    });
    if (!res.ok) throw new Error('Failed to fetch scenarios');
    const { scenarios } = await res.json();
    console.log('[AC] fetchScenarios ok', scenarios?.length || 0);
    dispatch({ type: LOAD_SCENARIOS_SUCCESS, payload: { modelId, scenarios } });
  } catch (err) {
    console.error('fetchScenarios failed', err);
  }
};

export const saveScenario = ({ modelId, scenarioId, name, mappedAgents, attributes, assessmentUuid, attackSurface, impact, status }) => async (dispatch) => {
  try {
    console.log('[AC] saveScenario', { modelId, scenarioId, hasAgents: !!mappedAgents, hasAttrs: !!attributes });
    const res = await authFetch('/.netlify/functions/saveScenario', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, scenarioId, name, mappedAgents, attributes, assessmentUuid, attackSurface, impact, status }),
    });
    if (!res.ok) throw new Error('Failed to save scenario');
    const { scenario } = await res.json();
    console.log('[AC] saveScenario ok', scenario);
    dispatch({ type: SAVE_SCENARIO_SUCCESS, payload: { modelId, scenario } });
  } catch (err) {
    console.error('saveScenario failed', err);
    dispatch({ type: SAVE_SCENARIO_FAILURE, payload: err.message });
  }
};

export const deleteScenario = ({ modelId, scenarioId, cascade = false }) => async (dispatch) => {
  try {
    const res = await authFetch('/.netlify/functions/deleteScenario', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, scenarioId, cascade }),
    });
    if (!res.ok) throw new Error('Failed to delete scenario');
    dispatch({ type: DELETE_SCENARIO_SUCCESS, payload: { modelId, scenarioId } });
  } catch (err) {
    console.error('deleteScenario failed', err);
    dispatch({ type: DELETE_SCENARIO_FAILURE, payload: err.message });
  }
};

// ─────────── Scenario naming (LLM suggestion) ───────────
export const REQUEST_SCENARIO_NAME_START = 'REQUEST_SCENARIO_NAME_START';
export const REQUEST_SCENARIO_NAME_SUCCESS = 'REQUEST_SCENARIO_NAME_SUCCESS';
export const REQUEST_SCENARIO_NAME_FAILURE = 'REQUEST_SCENARIO_NAME_FAILURE';

export const requestScenarioName = (modelId, scenarioId) => async (dispatch, getState) => {
  const state = getState();
  const scenario = state?.security?.models?.[modelId]?.scenarios?.[scenarioId] || {};
  const assessment = scenario?.assessmentData || {};
  const payload = {
    modelId,
    scenarioId,
    assessmentUuid: state?.security?.activeAssessmentUuid || null,
    attributes: assessment['Scenario Attributes'] || {},
    agents: scenario?.mappedAgents || [],
    attackSurface: assessment[state?.risks?.models?.[modelId]?.modelType?.toLowerCase().includes('generative') ? 'Attack Surface - Generative AI' : 'Attack Surface - Predictive AI'] || {},
    impact: assessment['Scenario Impact'] || {},
  };
  dispatch({ type: REQUEST_SCENARIO_NAME_START, payload: { modelId, scenarioId } });
  try {
    const res = await authFetch('/.netlify/functions/suggestScenarioName', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error('Failed to get scenario name suggestion');
    const { suggestion } = await res.json();
    dispatch({ type: REQUEST_SCENARIO_NAME_SUCCESS, payload: { modelId, scenarioId, suggestion } });
    return suggestion;
  } catch (err) {
    dispatch({ type: REQUEST_SCENARIO_NAME_FAILURE, payload: { modelId, scenarioId, error: err.message } });
    return null;
  }
};

// ─────────── Scenario phase-specific update thunks ───────────
export const updateScenarioAttributes = (modelId, scenarioId, attrName, values, assessmentUuid) => (dispatch, getState) => {
  const prev = getState()?.security?.models?.[modelId]?.scenarios?.[scenarioId]?.assessmentData?.['Scenario Attributes'] || {};
  const next = { ...prev, [attrName]: Array.isArray(values) ? values : [] };
  dispatch(updateScenarioAssessment(modelId, scenarioId, { 'Scenario Attributes': next }));
  return dispatch(saveScenario({ modelId, scenarioId, attributes: next, assessmentUuid }));
};

export const updateScenarioAgents = (modelId, scenarioId, agents, assessmentUuid) => (dispatch, getState) => {
  const nextAgents = Array.isArray(agents) ? agents : [];
  const prevName = getState()?.security?.models?.[modelId]?.scenarios?.[scenarioId]?.name;
  // Only persist on the scenario record; avoid duplicating under assessmentData
  return dispatch(
    saveScenario({ modelId, scenarioId, name: prevName, mappedAgents: nextAgents, assessmentUuid })
  );
};

export const updateAttackSurfaceField = (modelId, scenarioId, categoryName, attackType, rowData, assessmentUuid) => (dispatch, getState) => {
  const prev = getState()?.security?.models?.[modelId]?.scenarios?.[scenarioId]?.assessmentData?.[categoryName] || {};
  const next = { ...prev, [attackType]: rowData || {} };
  dispatch(updateScenarioAssessment(modelId, scenarioId, { [categoryName]: next }));
  return dispatch(saveScenario({ modelId, scenarioId, attackSurface: next, assessmentUuid }));
};

export const updateScenarioImpactField = (modelId, scenarioId, keyOrRationale, value, assessmentUuid) => (dispatch, getState) => {
  const prev = getState()?.security?.models?.[modelId]?.scenarios?.[scenarioId]?.assessmentData?.['Scenario Impact'] || {};
  const next = { ...prev, [keyOrRationale]: value };
  dispatch(updateScenarioAssessment(modelId, scenarioId, { 'Scenario Impact': next }));
  return dispatch(saveScenario({ modelId, scenarioId, impact: next, assessmentUuid }));
};
// In your actions.js file
export const saveSecurityRisk = (modelId, assessmentUuid, riskData) => async (dispatch) => {

  console.log ('security risks to dispatch to save', riskData)
  dispatch({ type: SAVE_SECURITY_RISK_START });
  try {
    const response = await authFetch('/.netlify/functions/saveSecurityRisks', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ risk: riskData, modelId, assessmentUuid }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const { risk } = await response.json();

    console.log ('sec risks returned from DB to reducer', risk)
    dispatch({ type: SAVE_SECURITY_RISK_SUCCESS, payload: { modelId, risk } });
  } catch (error) {
    console.error('Error saving risk:', error);
    dispatch({ type: SAVE_SECURITY_RISK_FAILURE, payload: error.message });
  }
};

export const fetchSecurityRisks = (modelId, assessmentUuid,allowGeneration = false ) => async (dispatch, getState) => {
  dispatch({ type: FETCH_SECURITY_RISKS_START });

  try {
      const response = await authFetch('/.netlify/functions/fetchSecurityRisks', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({ modelId, assessmentUuid })
      });

      if (!response.ok) {
          throw new Error('Failed to fetch security risks');
      }
      
      const result = await response.json();
      const risks = result.risks;
      
      dispatch({ type: FETCH_SECURITY_RISKS_SUCCESS, payload: { modelId, risks } });
      console.log('Fetched security risks:', risks);

      // Check if risks are empty and trigger generation if needed
      if (risks.length === 0 && allowGeneration) {
          console.log("No security risks found, generating new ones...");
          dispatch(generateSecurityRisks(modelId));
      }
  } catch (error) {
      console.error('Error fetching security risks:', error.message);
      dispatch({ type: FETCH_SECURITY_RISKS_FAILURE, payload: error.message });
  }
};


export const discardSecurityRisk = (modelId, riskId) => async (dispatch) => {
  dispatch({ type: DISCARD_SECURITY_RISK_START });
  try {
    const response = await authFetch('/.netlify/functions/discardSecurityRisk', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ riskId })
    });

    if (!response.ok) {
      throw new Error('Failed to discard security risk');
    }
    
    await response.json();
    dispatch({ type: DISCARD_SECURITY_RISK_SUCCESS, payload: { modelId, riskId } });
  } catch (error) {
    dispatch({ type: DISCARD_SECURITY_RISK_FAILURE, error: error.toString() });
  }
};


export const checkAndGenerateSecurityControls = (modelId) => (dispatch, getState) => {
  const { security } = getState();
  const model = security.models[modelId];
  if (!model) {
    console.error("Model not found:", modelId);
    return;
  }

  const { securityRisks, securityControls } = model;

  // Identify risks that lack controls
  const risksWithoutControls = securityRisks.filter(risk =>
    !securityControls[risk.risk_id] || securityControls[risk.risk_id].length === 0
  );

  if (risksWithoutControls.length > 0) {
    console.log("Generating controls for risks without controls in model:", modelId);
    dispatch(generateSecurityControls(modelId, risksWithoutControls));
  } else {
    console.log("All risks have controls, no generation needed.");
  }
};

export const generateSecurityControls = (modelId, risksWithoutControls) => async (dispatch, getState) => {
  dispatch({ type: GENERATE_SECURITY_CONTROLS_START, modelId });
  try {
    const state = getState();
    const assessmentData = state?.security?.models?.[modelId]?.assessmentData || {};
    const risksData = risksWithoutControls.map(risk => ({
      risk_id: risk.risk_id,
      risk_name: risk.risk_name || risk.name,
      category: risk.category,
      threat_level: risk.threat_level,
      vulnerability_level: risk.vulnerability_level,
      asset_value: risk.asset_value,
      justification: risk.justification,
      context: assessmentData,
    }));
    const response = await authFetch('/.netlify/functions/generateSecurityControls', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ modelId, risks: risksData })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const controlsPerRisk = await response.json();
    dispatch({ type: GENERATE_SECURITY_CONTROLS_SUCCESS, modelId, controlsPerRisk });
  } catch (error) {
    console.error("Error generating security controls:", error);
    dispatch({ type: GENERATE_SECURITY_CONTROLS_FAILURE, modelId, error: error.message });
  }
};






export const fetchSecurityControls = (modelId, scenarioId) => async (dispatch, getState) => {
  const existing = getState()?.security?.models?.[modelId]?.securityControls?.[scenarioId];
  // If we already have non-empty controls for this risk, avoid redundant fetch/overwrite
  if (Array.isArray(existing) && existing.length > 0) {
    return;
  }
  dispatch({ type: FETCH_SECURITY_CONTROLS_START });
  try {
    const state = getState();
    const assessmentUuid = state?.security?.activeAssessmentUuid || null;
    const response = await authFetch('/.netlify/functions/fetchSecurityControls', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ modelId, scenarioId, assessmentUuid })
    });

    if (!response.ok) {
      throw new Error('Failed to fetch security controls');
    }
    
    const { controls } = await response.json();
    // Do not overwrite an already non-empty set with an empty array
    if ((!controls || controls.length === 0) && Array.isArray(existing) && existing.length > 0) {
      return;
    }
    dispatch({ type: FETCH_SECURITY_CONTROLS_SUCCESS, payload: { modelId, riskId: scenarioId, controls: controls || [] } });
  } catch (error) {
    dispatch({ type: FETCH_SECURITY_CONTROLS_FAILURE, payload: error.message });
  }
};

// Save Control
export const saveSecurityControl = (controlData, modelId, scenarioId, assessmentUuid) => async (dispatch) => {
  dispatch({ type: SAVE_SECURITY_CONTROL_START });
  try {
    const response = await authFetch('/.netlify/functions/saveSecurityControls', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ controlData, modelId, scenarioId, assessmentUuid })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const { control } = await response.json();

    console.log ('saved sec control returned from db save', control)
    dispatch({ type: SAVE_SECURITY_CONTROL_SUCCESS, payload: { control, modelId, riskId: scenarioId } });
  } catch (error) {
    console.error('Error saving control:', error);
    dispatch({ type: SAVE_SECURITY_CONTROL_FAILURE, payload: error.message });
  }
};